import { render, staticRenderFns } from "./meal-goods-order.vue?vue&type=template&id=6d259e3e"
import script from "./meal-goods-order.vue?vue&type=script&lang=ts"
export * from "./meal-goods-order.vue?vue&type=script&lang=ts"
import style0 from "./meal-goods-order.vue?vue&type=style&index=0&id=6d259e3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports